import * as React from 'react';
import classNames from 'classnames';
import {Flex, Icon, Text, Link} from 'components/UIKit';
import styles from './Breadcrumbs.scss';

export type Breadcrumb = {
  label: string;
  path: string;
};

export interface BreadcrumbProps {
  breadcrumbs: Breadcrumb[];
}

export function Breadcrumbs({breadcrumbs}: BreadcrumbProps) {
  const lastIndex = breadcrumbs.length - 1;

  return (
    <Flex wrap="wrap" wrapperComponent="ul" className={styles.list}>
      {breadcrumbs.map((breadcrumb, index) =>
        <Flex
          wrapperComponent="li"
          className={styles.item}
          alignItems="center"
          key={breadcrumb.label}
        >
          {index === lastIndex
            ? (
              <Text
                text={breadcrumb.label}
                type="small"
                resetMargin
                className={classNames(styles.span, styles.label)}
              />
            ) : (
              <Link
                className={classNames(styles.label, styles.link)}
                type="small"
                secondary
                resetMargin
                text={breadcrumb.label}
                url={breadcrumb.path}
              />
            )}
          <Icon icon="chevronRight" fill="grey" className={styles.icon} />
        </Flex>)
      }
    </Flex>
  );
}

export default Breadcrumbs;
